module.exports = __webpack_public_path__ + "static/media/gc-hotel-room.bd81fceb.png";